/**
 * Save Stages Handlers
 */
import { saveStages, sendJourneyEmail } from './ajax.js';

const MIN_STAGES = 7;
const MAX_STAGES = 15;

/**
 * Initialize save stages handler
 */
export function initSaveStages() {
	const form = document.getElementById('save-stages-form');
	if (!form) return;
	const saveBtn = form.querySelector('[data-action="save-draft"]');

	if (!saveBtn) return;

	saveBtn.addEventListener('click', async (e) => {
		e.preventDefault();

		saveBtn.disabled = true;
		const originalText = saveBtn.textContent;
		saveBtn.textContent = wpcore.direct_t({ en: 'Saving...', fr: 'Enregistrement...' });

		try {
			const formData = new FormData(form);
			formData.append('journey_id', form.dataset.journeyId);

			const result = await saveStages(formData);

			wpcore.alert('success', wpcore.direct_t({ en: 'Stage', fr: 'Étape' }), wpcore.direct_t({ en: 'Stages saved successfully!', fr: 'Étapes enregistrées avec succès !' }));

			if (result.errors?.length > 0) {
				console.warn('Some errors occurred:', result.errors);
			}
		} catch (error) {
			wpcore.alert('error', wpcore.direct_t({ en: 'Stage', fr: 'Étape' }), error.message || wpcore.direct_t({ en: 'Failed to save stages.', fr: 'Échec de l\'enregistrement des étapes.' }));
		} finally {
			saveBtn.disabled = false;
			saveBtn.textContent = originalText;
		}
	});
}

/**
 * Initialize send email handler
 */
export function initSendEmail() {
	const mailForm = document.getElementById('send-mail-form');
	const stagesForm = document.getElementById('save-stages-form');

	if (!mailForm || !stagesForm) return;

	const sendBtn = mailForm.querySelector('[data-action="send-email"]');
	if (!sendBtn) return;

	sendBtn.addEventListener('click', async (e) => {
		e.preventDefault();

		// Validate stage count before sending
		const container = document.getElementById('stages-container');
		const stageCount = container ? container.querySelectorAll('.stage-item').length : 0;
		if (stageCount < MIN_STAGES || stageCount > MAX_STAGES) {
			wpcore.alert('error',
				wpcore.direct_t({ en: 'Stage', fr: 'Étape' }),
				wpcore.direct_t({
					en: `Journey must have between ${MIN_STAGES} and ${MAX_STAGES} stages (currently ${stageCount}).`,
					fr: `Le parcours doit contenir entre ${MIN_STAGES} et ${MAX_STAGES} étapes (actuellement ${stageCount}).`
				})
			);
			return;
		}

		sendBtn.disabled = true;
		const originalText = sendBtn.textContent;
		sendBtn.textContent = wpcore.direct_t({ en: 'Sending...', fr: 'Envoi...' });

		try {
			const formData = new FormData(stagesForm);
			const mailFormData = new FormData(mailForm);

			// Merge form
			for (const [key, value] of mailFormData.entries()) {
				formData.append(key, value);
			}

			formData.append('journey_id', stagesForm.dataset.journeyId);

			const result = await sendJourneyEmail(formData);

			wpcore.closePopup('message-send-mail');

			// Redirect to journey view detail page
			const journeyId = stagesForm.dataset.journeyId;
			if (journeyId) {
				window.location.href = `/journey/${journeyId}?view=detail`;
			}

		} catch (error) {
			wpcore.alert('error', wpcore.direct_t({ en: 'Email', fr: 'E-mail' }), error.message || wpcore.direct_t({ en: 'Failed to send email.', fr: 'Échec de l\'envoi de l\'e-mail.' }));
		} finally {
			sendBtn.disabled = false;
			sendBtn.textContent = originalText;
		}
	});
}
